// import React from "react";
import { GetStaticProps } from "next/types"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Page } from "types/page"
import DefaultErrorPage from "next/error"
import { SSRConfig } from "next-i18next"
import { ParsedUrlQuery } from "querystring"
import { CourseContent } from "interfaces/courses"
import CourseScreen from "@cs/screens/courses-beta/course-enroll/CourseScreen"
import { fetchCourseWithSlug, fetchCoursesSlug } from "@cs/lib/firebase/courses-v6/getCourses"

interface PageProps {
  courseSlug?: string
  course?: CourseContent
}

interface CoursePageProps extends SSRConfig, PageProps {}

interface Params extends ParsedUrlQuery {
  courseSlug: string
}

const CoursePage: Page<CoursePageProps> = ({ courseSlug, course }) => {
  if (!courseSlug || !course) return <DefaultErrorPage statusCode={404} />

  return <CourseScreen {...course} />
}

export default CoursePage

export const getStaticPaths = async () => {
  const paths = await fetchCoursesSlug()

  return {
    paths: paths.map(slug => ({ params: { courseSlug: slug } })),
    fallback: "blocking",
  }
}

export const getStaticProps: GetStaticProps<CoursePageProps, Params> = async ({
  locale,
  params,
}) => {
  const response: PageProps = {
    courseSlug: undefined,
    course: undefined,
  }

  response.courseSlug = params?.courseSlug

  if (response.courseSlug) {
    response.course = await fetchCourseWithSlug(response.courseSlug, locale ?? "en")
  }

  return {
    props: {
      ...response,
      ...(await serverSideTranslations(
        locale ?? "en",
        ["common", "footer", "nav", "courses", "landing-page"],
        nextI18nextConfig,
      )),
    },
  }
}
